import React, { type ReactElement } from 'react';

import { ButtonBoxPrimary, ButtonBoxSecondary } from './button.styles';
import { ButtonProps } from './button.types';

export function Button(props: ButtonProps): ReactElement | null {
  const { isDisabled, view, ...rest } = props;

  switch (view) {
    case 'primary':
      return (
        <ButtonBoxPrimary {...rest} disabled={isDisabled} />
      );
    case 'secondary':
      return (
        <ButtonBoxSecondary {...rest} disabled={isDisabled} />
      );
    default:
      return null;
  }
}
